import { useTranslation } from "react-i18next";
import { Divider, Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import { OneI, PlanIT, Sms, Xentry } from "modules/DealerOverviewDashboard/components/Service/components";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const ASTERISK_PLACEHOLDER = "••••••••";

type ServiceProps = {
  tabId: string;
};

export const Service = ({ tabId }: ServiceProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-overview-section">
      <div className="section-title">
        <div>
          <Icon className="wrench" />
        </div>
        <span className="section-title-text">{t("v8_service", "Service")}</span>
      </div>
      <div className="dealer-overview-subheading">{t("v8_integrations", "Integrations")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_web_clock_url", "WebClock URL")}</label>
          <FormHelper.Field.Input
            name="web_clock_url"
            inputProps={{ placeholder: "http://demo.com/TruckVision/KlokSysteem/Account/Login.aspx?omgvid=@omgvid&mwnt=@mwnt&dsornr=@dsornr&src=claireit" }}
          />
        </Form.Field>
      </Form.Group>
      <Divider />
      <Xentry />
      <Divider />
      <Sms />
      <Divider />
      <Form.Group className="planning-integrations-group">
        <PlanIT />
        <OneI />
      </Form.Group>
    </Element>
  );
};
